import { LanguagesAbbr, SessionTypesEnum } from "../types/working-model";
import { niceDateTime } from '../utils/utils';
import { useTranslate } from "../i18n/useTranslationModules";
import { AgendaLayoutTypesClassic } from "../types/template-layouts";
import { useIsNewNavigation } from "./navigation.hooks";

export const useGetSessionTypeName = (session_type: SessionTypesEnum): string => {
	const { t } = useTranslate(["homepage", "landing"]);

	switch (session_type) {
		case SessionTypesEnum.broadcast: {
			return t("homepage:Broadcast", "");
		}
		case SessionTypesEnum.breakoutRooms: {
			return t("homepage:Breakout Rooms", "");
		}
		case SessionTypesEnum.fireside: {
			return t("homepage:Fireside", "");
		}
		default: {
			return t("homepage:On Demand", "");
		}
	}
};

type TUseGetTagText = (params: {
	session_type: SessionTypesEnum;
	shouldShowTimestamp: boolean;
	timestamp: number | null;
	language: LanguagesAbbr;
	tracks: string[] | null;
}) => string;

export const useGetTagText: TUseGetTagText = ({
	session_type,
	shouldShowTimestamp,
	timestamp,
	language,
	tracks
}) => {
	const sessionTypeName = useGetSessionTypeName(session_type);
	const niceTimestamp = timestamp && niceDateTime(timestamp, language);
	const tracksList = tracks?.length ? ` \u00B7 ${tracks.join(', ')}` : '';

	return shouldShowTimestamp ? `${niceTimestamp} \u00B7 ${sessionTypeName}${tracksList}` : sessionTypeName;
};

export const useGetLayoutType = (layout_type?: AgendaLayoutTypesClassic) => {
	const isNewNavigation = useIsNewNavigation();

	if (isNewNavigation && layout_type === AgendaLayoutTypesClassic.standard) {
		return AgendaLayoutTypesClassic.ltr;
	}

	if (layout_type) return layout_type;

	return AgendaLayoutTypesClassic.standard;
};
